import { Component, Inject } from "@angular/core";
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { AuctionDTO } from "@shared/model/auction.model";
import { AuctionService } from "@shared/services/auction/auction.service";

@Component({
	selector: "app-extend-time-dialog",
	templateUrl: "./extend-time-dialog.component.html",
	styleUrl: "./extend-time-dialog.component.scss",
	standalone: false
})
export class ExtendTimeDialogComponent {
	bsConfig = {
		containerClass: "theme-red",
		adaptivePosition: true,
		dateInputFormat: "DD/MM/YYYY"
	};
	auctionForm: UntypedFormGroup;
	constructor(
		public dialogRef: MatDialogRef<ExtendTimeDialogComponent>,
		private auctionService: AuctionService,
		@Inject(MAT_DIALOG_DATA) public auction: AuctionDTO,
		private formBuilder: UntypedFormBuilder
	) {
		this.auctionForm = this.formBuilder.group(
			{
				dateFrom: new UntypedFormControl(""),
				hourFrom: new UntypedFormControl(""),
			});

		const start = new Date(auction.startDate),
			end = new Date(auction.endDate);

		this.auction.startDate =
			this.auction.startTime = start;
		this.auction.endDate =
			this.auction.endTime = end;

		this.auctionForm.controls["dateFrom"].disable();
		this.auctionForm.controls["hourFrom"].disable();
	}

	close() {
		this.dialogRef.close();
	}

	extend() {
		const endDate: Date = new Date(this.auction.endDate),
			endTime: Date = new Date(this.auction.endTime);
		endDate.setHours(endTime.getHours(), endTime.getMinutes(), 0);

		this.auction.endDate = endDate;

		this.auctionService.resizeEndTimeUsingPATCH(this.auction, this.auction.idAuction).subscribe(() => {
			this.dialogRef.close(this.auction.endDate);
		});
	}
}